function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Takes an array containing arrays and returns an array composed of the elements of the inner array.
 *
 * Ex: `[[a, b], [c, d]]` =\> `[a, b, c, d]`
 * @param arrayOfArrays -
 */
export function arrayFlatten(arrayOfArrays) {
  return arrayOfArrays.reduce(function (flatter, array) {
    return flatter.concat(array);
  }, []);
}

/**
 * Returns an array containing the elements in array `a` that are *not* in array `b`
 *
 * if elements in either array have an `id` property, that is used for comparison. If not, simple equality is used.
 *
 * @param a - items which may or may not also be in `b`
 * @param b - items to remove from `a`
 */
export function arraySubtract(a, b) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return a.filter(function (elA) {
    // True if elA is not in b
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return b.every(function (elB) {
      // Compare IDs if available, otherwise compare references
      return (elA.id || elA) !== (elB.id || elB);
    });
  });
}

/*

Pseudocode

original: [a,b,c,d,e,f,g,h]
offset: 3
insert: [d,x,f]

returns: [a,b,c,d,x,f,e,g,h]

arrayMerge([a,b,c,d,e,f,g,h], 3, [d,x,f])
	head = [a,b,c]
	tail = [d,e,f,g,h]
	before = (head - [d,x,f]) = [a,b,c]
	after = (tail - [d,x,f]) = [e,g,h]
	return [a,b,c] + [d,x,f] + [e,g,h] = [a,b,c,d,x,f,e,g,h]

*/

/**
 * Merges `insert` into `original` starting at `offset`, removing duplicates.
 * If `truncate` is truthy, drops all items left after `offset` after adding `insert`
 *
 * @param original -
 * @param offset -
 * @param insert -
 * @param truncate -
 */
export function arrayMerge(original, offset, insert) {
  var truncate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // Get all the elements in the original array before and after the split,
  // minus any elements in the second array

  var head = original.slice(0, offset);
  var tail = original.slice(offset);
  var before = arraySubtract(head, insert);
  var after = truncate ? [] : arraySubtract(tail, insert);
  return Array.of.apply(Array, _toConsumableArray(before).concat(_toConsumableArray(insert), _toConsumableArray(after)));
}

/**
 * @returns true if both arrays are of equal length and contain the same items using a strict comparison (`===`) of each item.
 * @param a -
 * @param b -
 */
export function arrayEquals(a, b) {
  return a.length === b.length && a.every(function (elA, i) {
    return elA === b[i];
  });
}
/**
 * Splits a single array into zero or more arrays depending what `discriminator` returns given an element of the given array.
 *
 * Example:
 * ```ts
 * const array = ['a', 'ab', 'abcde', 'abcdef'];
 * const {short, long} = arrayPartition(array, el => {
 *     return (el.length < 3) ? 'short' : 'long';
 * });
 *
 * short === ['a', 'ab'];
 * long === ['abcde', 'abcdef']
 * ```
 *
 * @returns object with keys corresponding to `discriminator` return values
 * @param array - input values
 * @param discriminator - function that takes an array element and returns a string indicating which partition the given element belongs to
 */
export function arrayPartition(array, discriminator) {
  return array.reduce(function (accum, el) {
    var key = discriminator(el);
    accum[key].push(el);
    return accum;
  }, createBagOfArrays());
}

/**
 * Creates a special object where all keys produce an array.
 * The same key will always produce the same array,
 * a key that hasn't been accessed before produces an empty array.
 *
 * If you have a better name than "bag of arrays" please contact Drew Benson.
 */
export function createBagOfArrays() {
  return new Proxy({}, {
    get: function get(target, prop) {
      if (!target[prop]) {
        target[prop] = [];
      }
      return target[prop];
    }
  });
}
